import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import styles from "./adiantamento.module.css";
import api from "../../../services/api";
import BottomNav from "../../../components/BottomNav";
import ApiButton from "../../../components/ApiButton/ApiButton";
import BackIcon from "../../../components/BackIcon";

export default function Adiantamento() {
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();

    const [ano, setAno] = useState(new Date().getFullYear());
    const [mes, setMes] = useState(new Date().getMonth() + 1);
    const [dados, setDados] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pdfLoading, setPdfLoading] = useState(false);

    const consultar = async () => {
        try {
            setLoading(true);

            const mesano = `${mes}${ano}`;

            const response = await api.get(`/colaborador/infocolaborador/?cpffun=${user.cpffun}&tipfun=${user.tipfun}&tipdad=A&mesano=${mesano}`);

            setDados(response.data);

        } catch (error) {
            console.error(error);
            alert("Erro ao consultar Vale");
        } finally {
            setLoading(false);
        }
    };


    const visualizarPDF = async () => {
        // Abre a aba em branco de forma síncrona (ainda dentro do gesto de clique do
        // usuário) e só depois troca a URL pro blob assim que o PDF chega - se
        // esperasse o fetch terminar pra chamar window.open, o navegador (principalmente
        // mobile) trata como popup não solicitado e bloqueia.
        const pdfWindow = window.open('', '_blank');
        try {
            setPdfLoading(true);

            const mesano = `${mes}${ano}`;

            const response = await api.get(`/colaborador/holerite/?cpffun=${user.cpffun}&tipfun=${user.tipfun}&tipdad=A&mesano=${mesano}`, {

                responseType: "blob"
            });

            const url = window.URL.createObjectURL(
                new Blob([response.data], { type: "application/pdf" })
            );

            if (pdfWindow) {
                pdfWindow.location.href = url;
            } else {
                alert("Permita pop-ups pra visualizar o PDF");
            }

        } catch (error) {
            if (pdfWindow) pdfWindow.close();
            let msg = "Erro ao gerar PDF";
            try {
                if (error.response?.data instanceof Blob) {
                    const texto = await error.response.data.text();
                    const json = JSON.parse(texto);
                    if (json.msg) msg = json.msg;
                } else if (error.response?.data?.msg) {
                    msg = error.response.data.msg;
                }
            } catch {
                // corpo do erro não veio em JSON legível - mantém a mensagem genérica
            }
            console.error(error);
            alert(msg);
        } finally {
            setPdfLoading(false);
        }
    };



    {/*const gerarPDF2 = async () => {
        try {
            const mesano = `${mes}${ano}`;

            const response = await api.get(`/colaborador/holerite/?cpffun=${user.cpffun}&tipfun=${'F'}&tipdad=H&mesano=${mesano}`, {

                responseType: "blob"
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Holerite.pdf");
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            alert("Erro ao gerar PDF");
        }
    };*/}

    const creditos = dados.filter(d => d.tiplan === "C");
    const debitos = dados.filter(d => d.tiplan === "D");

    const totalCreditos = creditos.reduce((acc, item) => acc + item.valpon, 0);
    const totalDebitos = debitos.reduce((acc, item) => acc + item.valpon, 0);
    const liquido = totalCreditos - totalDebitos;

    const formatarMoeda = (valor) =>
        new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL"
        }).format(valor);

    return (
        <div className={styles.container}>

            {/* HEADER */}
            <div className={styles.header}>
                <button className={styles.btnVoltar} onClick={() => navigate(-1)}><BackIcon /></button>
                <div className={styles.headerTexto}>
                    <h2>Vale Adiantamento</h2>
                    <p>Acompanhe e imprima seu vale</p>
                </div>
            </div>

            {/* FILTROS */}
            <div className={styles.card}>
                <span className={styles.cardTitulo}>🔍 Período</span>
                <div className={styles.filtros}>
                    <select value={ano} onChange={e => setAno(e.target.value)}>
                        {[2024, 2025, 2026].map(a => (
                            <option key={a} value={a}>{a}</option>
                        ))}
                    </select>
                    <select value={mes} onChange={e => setMes(e.target.value)}>
                        {Array.from({ length: 12 }, (_, i) => (
                            <option key={i + 1} value={i + 1}>{String(i + 1).padStart(2, '0')}</option>
                        ))}
                    </select>
                    <ApiButton className={styles.btnConsultar} onClick={consultar} disabled={loading}>
                        {loading ? "..." : "Consultar"}
                    </ApiButton>
                </div>
            </div>

            {/* RESUMO + TABELA */}
            {!loading && dados.length > 0 && (
                <>
                    <div className={styles.card}>
                        <span className={styles.cardTitulo}>💰 Resumo financeiro</span>
                        <div className={styles.resumoItem}>
                            <span>Créditos</span>
                            <strong className={styles.creditoValor}>{formatarMoeda(totalCreditos)}</strong>
                        </div>
                        <div className={styles.resumoItem}>
                            <span>Débitos</span>
                            <strong className={styles.debitoValor}>{formatarMoeda(totalDebitos)}</strong>
                        </div>
                        <div className={`${styles.resumoItem} ${styles.liquido}`}>
                            <span>Líquido a receber</span>
                            <strong>{formatarMoeda(liquido)}</strong>
                        </div>
                        <ApiButton className={styles.btnPreview} onClick={visualizarPDF} disabled={pdfLoading}>
                            {pdfLoading ? "Gerando PDF..." : "Visualizar PDF"}
                        </ApiButton>
                    </div>

                    <div className={styles.card}>
                        <span className={styles.secaoLabel}>Proventos</span>
                        {creditos.map(item => (
                            <div key={item.seqreg} className={styles.linha}>
                                <span>{item.deseve}</span>
                                <span className={styles.creditoValor}>{formatarMoeda(item.valpon)}</span>
                            </div>
                        ))}
                        <span className={styles.secaoLabel}>Descontos</span>
                        {debitos.map(item => (
                            <div key={item.seqreg} className={styles.linha}>
                                <span>{item.deseve}</span>
                                <span className={styles.debitoValor}>- {formatarMoeda(item.valpon)}</span>
                            </div>
                        ))}
                    </div>
                </>
            )}

            <BottomNav />
        </div>
    );
}